import $ from 'jquery';

// Components
import './components/nav';
import './components/slides';
import './components/page-builder';
import './components/projects';

// Forms
import FormValidation from './components/forms';

$('.js-form-validate').each((index, element) => {
    /* eslint-disable no-new */
    new FormValidation(element);
});

require('jquery.ns-autogrow');

$('.contact__form textarea').autogrow({ vertical: true, horizontal: false });



// WEBPACK FOOTER //
// ./source/scripts/app.js